import { FC, useCallback } from 'react'
import { SlateReactPresentation } from 'slate-react-presentation'

import { Element } from './element'
import { Leaf } from './leaf'

export type WysiwygRendererProps = {
  document?: any
}

const WysiwygRenderer: FC<WysiwygRendererProps> = ({ document }) => {
  const renderElement = useCallback((props) => <Element {...props} />, [])
  const renderLeaf = useCallback((props) => <Leaf {...props} />, [])

  return (
    <SlateReactPresentation
      value={document}
      renderElement={renderElement}
      renderLeaf={renderLeaf}
    />
  )
}

export default WysiwygRenderer
